import { createSelector } from 'reselect';
import _ from 'lodash';
import { GetRegion } from 'constants.js';
import { getDetailPageEventState, getMetadata } from './index';

export const getEventInfo = createSelector(
  [getDetailPageEventState],
  detailPageState => _.get(detailPageState, 'eventInfo'),
);

export const getGroupId = createSelector(
  [getEventInfo],
  eventInfo => _.get(eventInfo, 'model.groupId'),
);

export const getEventId = createSelector(
  [getEventInfo],
  eventInfo => _.get(eventInfo, 'model.eventId'),
);

export const getSafeTime = createSelector(
  [getMetadata],
  metadata => {
    const d = { start: 0, end: 0 };
    const o = JSON.parse(_.get(metadata, 'epg_event_safe_time', '{}'));
    const config = _.get(
      o,
      [GetRegion(), 'timeshift'],
      _.get(o, ['default', 'timeshift'], d),
    );
    return config;
  },
);
